export class RestaurantDetails {
  index: number;
  id: number;
  photo: string;
  restaurantName: string;
  typeName: string;
  status: string;
  cuisineName: string;
  priceRange: string;
  cityName: string;
  address: string;
  rank: number;
  rating: number;
  openWeeksHours: string[];
  coordinate: any;
  isVisible: boolean;
  membershipAppCompanyBusinessHourList: any = [];
  membershipBusinessImagesList: any = [];
  toolTipHours: any = [];
  tags: any = [];
  showMore: boolean;
  memberShipImageConfigurationList: any = [];
  distance: number;
  zoomLevel: number;
  /** Google Maps directions URL, or '' when the branch has neither coords nor an address. */
  directionsUrl: string;
}


export enum RestaurantListType {
  Popular = 1,
  OpenNow,
  Delivery,
  Nearby
}


export class RestaurantListFilter {
  restaurantListType: RestaurantListType;
  public searchText: string;
  public ratings: number[];
  public priceRanges: number[];
  public mealTypes: number;
  public pageNumber: number;
}

